import { Dispatch } from 'redux'
import { updateSetting } from 'util/server/settings'
import { sendNativeMessage } from 'util/native'
import { getProfileSettings } from './profile'

export function setLanguagePreference(profile_id: number, language: string) {
  return (dispatch: Dispatch<any>) => {
    return updateSetting(profile_id, 'preferred_language', language).then(async () => {
      sendNativeMessage({ type: 'LANGUAGE_UPDATED', language })
      return dispatch(getProfileSettings(profile_id))
    })
  }
}
